<template>
  <div class="card fuel-funds__card h-mobile-no-border-radius">
    <div class="card-header">
      <h1 class="fuel-funds__card-title">Credits</h1>
    </div>
    <div class="card-body">
      <table class="maincol__table">
        <tr class="table__row table__row--head table__row--head--credits">
          <td class="table__cell table__cell--date">Date</td>
          <td class="table__cell table__cell--amount">Amount</td>
          <td class="table__cell table__cell--amount">Used</td>
          <td class="table__cell table__cell--remaining">Remaining</td>
          <td class="table__cell table__cell--action"></td>
        </tr>
        <FuelFundsCredit v-for="(credit, index) in credits" :key="index" :credit="credit"></FuelFundsCredit>
      </table>
    </div>
    <div class="card-footer">
      <div class="fuel-funds__card-total">
        <span class="fuel-funds__card-total--transactions">Total - Used =</span> <span class="fuel-funds__total--amount">${{ creditsTotal }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelFundsCredit from './FuelFundsCredit.vue';

  export default {
    name: 'FuelFundsCredits',
    components: {
      FuelFundsCredit,
    },
    computed: {
      ...mapGetters('fuelFunds', ['credits', 'creditsTotal']),
    },
  };
</script>
